export default [
  { type: 'text', author: `me`, id: 0, data: { text: `Hello!` } },
  { type: 'text', author: `robot`, id: 1, data: { text: `Hi~` } },
  { type: 'text', author: `me`, id: 2, data: { text: `哈哈哈😆` } }
]
